// extracted by mini-css-extract-plugin
var _1 = "TrackingNumber_container__RLjVi";
var _2 = "TrackingNumber_externalTrackingLinkContainer__8BxKG";
var _3 = "TrackingNumber_noCarrierImage__NmaLg";
var _4 = "TrackingNumber_trackingCarrier__BXrTt";
var _5 = "TrackingNumber_trackingCopyButton__bFybp";
var _6 = "TrackingNumber_trackingNumber__a9i6P";
var _7 = "TrackingNumber_trackingNumberContainer__suYzL";
var _8 = "TrackingNumber_trackingNumberTitle__upLu6";
export { _1 as "container", _2 as "externalTrackingLinkContainer", _3 as "noCarrierImage", _4 as "trackingCarrier", _5 as "trackingCopyButton", _6 as "trackingNumber", _7 as "trackingNumberContainer", _8 as "trackingNumberTitle" }
